import React, { useState } from 'react';
import * as Styles from './ProfileImageUpload.styles';
import { Button } from 'gatorcomponents';
import IconCamera from '../IconCamera';
import withErrorBoundary from '@/utils/errorBoundary';
import { ProfileImageModal } from '../ProfileImageModal';

const ProfileImageUpload = ({
  testId = 'profile-image-upload',
  locale = {},
  profileImage = null,
  onImageUpload = () => null,
  onImageDelete = () => null,
  onValidationError = () => null,
  isDeleting = false,
  isUploading = false,
}) => {
  const [isValidating] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = (errorKey) => {
    setShowModal(false);
    if (errorKey) {
      onValidationError(errorKey);
    }
  };

  const handleImageReadyFromModal = (file, previewUrl) => {
    onImageUpload(file, previewUrl);
  };

  return (
    <Styles.Wrapper data-testid={testId}>
      <Styles.Content>
        <Styles.AvatarWrapper>
          {profileImage ? (
            <Styles.Avatar src={profileImage} alt="Profile" />
          ) : (
            <Styles.AvatarPlaceholder>
              <IconCamera />
            </Styles.AvatarPlaceholder>
          )}
        </Styles.AvatarWrapper>

        <Styles.TextWrapper>
          <Styles.Label>
            {locale.profileImageLabel}
          </Styles.Label>
          <Styles.ButtonWrapper>
            {profileImage ? (
              <>
                <Button
                  label={locale.changeImageButton}
                  onClick={openModal}
                  disabled={isValidating || isDeleting}
                  variant="primary"
                />
                <Styles.RemoveButton>
                  <Button
                    label={locale.removeImageButton}
                    onClick={onImageDelete}
                    disabled={isValidating || isDeleting}
                    loading={isDeleting}
                    variant="secondary"
                  />
                </Styles.RemoveButton>
              </>
            ) : (
              <Button
                label={locale.addImageButton}
                onClick={openModal}
                disabled={isValidating}
              />
            )}
          </Styles.ButtonWrapper>
        </Styles.TextWrapper>

        <ProfileImageModal
          isOpen={showModal}
          onClose={closeModal}
          onImageReady={handleImageReadyFromModal}
          isUploading={isUploading}
          locale={{
            title: locale.profileImageModalTitle || 'Selecionar imagem',
            dragTitle: locale.profileImageModalDragTitle || 'Selecione uma imagem do seu dispositivo ou arraste e solte o arquivo nessa área.',
            recommendation: locale.profileImageModalRecommendation || 'Recomendamos um tamanho mínimo de 400 x 400 pixels. Sua imagem precisa estar no formato JPG ou PNG e ter até 5 MB.',
            errorTooLarge: locale.profilePictureInvalidSizeText || 'A imagem selecionada é muito grande. Selecione um arquivo com até 5 MB.',
            errorInvalidType: locale.profilePictureInvalidTypeText || 'A imagem selecionada está em um formato não suportado. Selecione um arquivo no formato JPG ou PNG.',
            buttonPick: locale.profileImageModalPickButton || 'Buscar imagem',
            uploading: locale.profileImageModalUploading || 'Carregando sua imagem',
            cancelUpload: locale.profileImageModalCancel || 'Cancelar envio',
          }}
        />
      </Styles.Content>
    </Styles.Wrapper>
  );
};

export default withErrorBoundary(ProfileImageUpload, 'ProfileImageUpload');
